export default "__VITE_ASSET__BLi2qtKl__"